<template>
    <div class="version1-middleBlock-top">
        <div v-for="(item,index) in list" :key="index" class="top-row" @click="detailClick(item)">
            <img :src="item.imgStr" alt="" class="top-row-b">
            <div class="top-content">
                <div class="top-row-name">
                    <span :style="{'color': item.color}">{{ item.label }}</span>
                    <img :src="item.arrow" alt="">
                </div>
                <div class="count" :style="{'color': item.color}">{{ item.count }}</div>
                <div class="pre">同比+{{ item.per }} <img src="../../../../../static/version1/13.png" alt="" ></div>
            </div>
            <div class="line" v-if="index !== list.length - 1"></div>
        </div>
    </div>
</template>

<script>
import { perIncrease } from '@/api/databaseBin'
import BaseMixin from '@/views/_mixin'
export default {
  mixins: [BaseMixin],
  data() {
    return {
      list: [
        {
          imgStr: require('../../../../../static/version1/专利总数.png'),
          label: '专利总数',
          count: 23232,
          per: '22.2%',
          arrow: require('../../../../../static/version1/专利总数箭头.png'),
          color: '#FED52F',
          name: 'apply',
          exp: '专利类型=(发明申请 or 实用新型 or 外观设计)'
        },
        {
          imgStr: require('../../../../../static/version1/专利授权数.png'),
          label: '专利授权',
          count: 23232,
          per: '22.2%',
          arrow: require('../../../../../static/version1/专利授权数箭头.png'),
          color: '#00FFFC',
          name: 'authorization',
          exp: '专利类型=(发明授权 or 实用新型 or 外观设计)'
        },
        {
          imgStr: require('../../../../../static/version1/专利有效数.png'),
          label: '专利有效',
          count: 2323,
          per: '22.2%',
          arrow: require('../../../../../static/version1/专利有效数箭头.png'),
          color: '#89B8FF',
          name: 'effect',
          exp: '专利类型=(发明授权 or 实用新型 or 外观设计) and 专利状态=(有效)'
        }
      ]
    }
  },
  mounted() {
    this.getTotal()
  },
  methods: {
    getTotal() {
      perIncrease().then((res) => {
        console.log(res)
        res.data.forEach(item => {
          this.list.forEach(ele => {
            if (item.name === ele.name) {
              ele.per = item.per
              ele.count = item.count
            }
          })
        })
      })
    },
    detailClick(item) {
      this.jumpIpi(item.exp)
    }
  }
}
</script>
